import { styled, Box, Dialog } from "@mui/material";

export const ControlPanelWrapper = styled(Box)`
  pointer-events: none;
  position: absolute;
  width: 100vw;
  top: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
`;

export const BootstrapDialog = styled(Dialog)(({}) => ({
  ".MuiDialog-paper": {
    maxWidth: "300px",
  },
}));
